import { Component, Input } from '@angular/core';
import { ViewMode } from '../../../../models';
import { SubscriptionSelectorType, TRANSPARENT_APPEARANCE } from '../../../extension-components/cart-control/config';

@Component({
  selector: 'cart-control-example',
  templateUrl: './cart-control-example.component.html',
  styleUrls: ['./cart-control-example.component.scss'],
  standalone: false,
})
export class CartControlExampleComponent {
  @Input() template;
  @Input() mode: ViewMode = null;
  @Input() isMobile: boolean = false;

  isEditOpen: boolean = true;
  SubscriptionSelectorType = SubscriptionSelectorType;

  get configurations() {
    return this.template?.configurations || {};
  }

  get changeVariant(): boolean {
    return this.configurations.changeVariant ?? false;
  }

  get editQuantity(): boolean {
    return this.configurations.editQuantity ?? false;
  }

  get removeItems(): boolean {
    return this.configurations.removeItems ?? false;
  }

  get showSubscriptionSelector(): boolean {
    return this.configurations.showSubscriptionSelector ?? false;
  }

  get subscriptionSelectorType(): SubscriptionSelectorType {
    return this.configurations.subscriptionSelectorType ?? SubscriptionSelectorType.DEFAULT_SELECTOR;
  }

  get buttonLabel(): string {
    return this.configurations.buttonLabel ?? 'Edit';
  }

  get buttonAppearance(): string {
    return this.configurations.buttonAppearance ?? 'accent';
  }

  get upgradeButtonLabel(): string {
    const text = this.configurations.upgradeButtonLabel ?? 'Upgrade to {subscription_group}';
    return text.replace('{subscription_group}', 'Subscribe & Save');
  }

  get upgradeButtonAppearance(): string {
    return this.configurations.upgradeButtonAppearance ?? TRANSPARENT_APPEARANCE;
  }

  get upgradeButtonTextColor(): string {
    return this.configurations.upgradeButtonTextColor ?? 'accent';
  }

  get isTransparentUpgradeButton(): boolean {
    return this.upgradeButtonAppearance === TRANSPARENT_APPEARANCE;
  }

  get hasAnyOption(): boolean {
    return this.changeVariant || this.editQuantity || this.removeItems || this.showSubscriptionSelector;
  }

  get showUpgradeButton(): boolean {
    return this.showSubscriptionSelector && this.subscriptionSelectorType === SubscriptionSelectorType.UPGRADE;
  }

  get showSubscriptionSelect(): boolean {
    return this.showSubscriptionSelector && this.subscriptionSelectorType === SubscriptionSelectorType.DEFAULT_SELECTOR;
  }

  get isOnlyRemove(): boolean {
    return (
      this.removeItems &&
      !this.changeVariant &&
      !this.editQuantity &&
      (!this.showSubscriptionSelector || this.subscriptionSelectorType === SubscriptionSelectorType.UPGRADE)
    );
  }

  get isOnlyUpgradeButton(): boolean {
    return this.showUpgradeButton && !this.changeVariant && !this.editQuantity && !this.removeItems;
  }

  toggleEdit(): void {
    this.isEditOpen = !this.isEditOpen;
  }
}
